import React from 'react';
import { CADThicknessWorkspace } from '../../components/cad';
import { CADModel } from '../../types/cad';
import { User } from '../../types';
import CadDeleteConfirmDialog from './CadDeleteConfirmDialog';

interface CadThicknessRouteProps {
  models: CADModel[];
  selectedModel: CADModel | null;
  currentUser: User | null;
  error: string | null;
  onClearError: () => void;
  onSelectModel: (model: CADModel) => void;
  onUploadComplete: (model: CADModel) => void;
  onDeleteModel: (modelId: string) => void;
  onEditClassification: (model: CADModel) => void;
  deleteDialogOpen: boolean;
  onCloseDeleteDialog: () => void;
  onConfirmDelete: () => void;
  onExitThicknessMode?: () => void;
}

/**
 * The `?mode=thickness` route: resolves the current user's roles into the two
 * capability flags the thickness workspace needs, then renders it alongside the
 * shared delete dialog. Role logic and markup are unchanged from the inline
 * branch it replaced.
 */
const CadThicknessRoute: React.FC<CadThicknessRouteProps> = ({
  models,
  selectedModel,
  currentUser,
  error,
  onClearError,
  onSelectModel,
  onUploadComplete,
  onDeleteModel,
  onEditClassification,
  deleteDialogOpen,
  onCloseDeleteDialog,
  onConfirmDelete,
  onExitThicknessMode,
}) => {
  const roles = Array.from(
    new Set([
      currentUser?.role,
      ...(currentUser?.roles || []),
    ].filter(Boolean)),
  );
  const canAnalyze = roles.some((role) =>
    ['user', 'manager', 'admin'].includes(String(role)),
  );
  const canDelete = roles.some((role) =>
    ['manager', 'admin'].includes(String(role)),
  );

  return (
    <>
      <CADThicknessWorkspace
        models={models}
        selectedModel={selectedModel}
        canAnalyze={canAnalyze}
        canDelete={canDelete}
        error={error}
        onClearError={onClearError}
        onSelectModel={onSelectModel}
        onUploadComplete={onUploadComplete}
        onDeleteModel={onDeleteModel}
        onEditClassification={onEditClassification}
        onExitThicknessMode={onExitThicknessMode}
      />
      <CadDeleteConfirmDialog
        open={deleteDialogOpen}
        onClose={onCloseDeleteDialog}
        onConfirm={onConfirmDelete}
      />
    </>
  );
};

export default CadThicknessRoute;
